import { StyledSection, StyledTitle, StyledContainer, StyledSubtitle, StyledContent } from '@/components/styles'
import { Hero,  MainSpecialists, MetaData, PartitionGrid, MainNumbers,ActiveLink,MainGallery } from '@/components'
import genLinkParams from '@/lib/generateLinkParams'
import { useTranslation } from "react-i18next";

const HomePage = ({
  banners,
  directions,
  specialists,
  galleries,
  meta
}) => {
  const [servicesHref, servicesAs] = genLinkParams({ type: 'services' });
  const [specialistsHref, specialistsAs] = genLinkParams({ type: 'specialists' });
  const [galleryHref, galleryAs] = ['about-us#gallery', 'about-us#gallery'];
  const { t } = useTranslation("global");

  return (
    <>
      <MetaData title={meta?.title || ''} description={meta?.description || ''}/>
      <Hero data={[...banners]} />
      
      <StyledSection pt="x-large" pb="x-large" backgroundColor>
        <StyledContainer>
          <StyledTitle size="large" center upper>{t('main.numbers.title')}</StyledTitle>
          <MainNumbers/>
        </StyledContainer>
      </StyledSection>

      <StyledSection  pb="none" mobOrder="-1" pbMob>
        <StyledContainer>
          <StyledTitle size="large" center upper mb="x-small">{t('main.servises.title')}</StyledTitle>
          <StyledSubtitle>{t('main.servises.subtitle')}</StyledSubtitle>
          <PartitionGrid directions={directions} />
          <ActiveLink  href={servicesHref} as={servicesAs}>
            <StyledContent.Link arrow>{t('main.servises.button')}</StyledContent.Link>
          </ActiveLink>
        </StyledContainer>
      </StyledSection>

      <StyledSection pb="none">
        <StyledContainer>
          <StyledTitle size="large" center upper mb="x-small">{t('main.specialists.title')}</StyledTitle>
          <StyledSubtitle>{t('main.specialists.subtitle')}</StyledSubtitle>
          <MainSpecialists specialists={specialists} />
          <ActiveLink  href={specialistsHref} as={specialistsAs}>
            <StyledContent.Link arrow>{t('main.specialists.button')}</StyledContent.Link>
          </ActiveLink>
        </StyledContainer>
      </StyledSection>

      <StyledSection overflowHidden>
        <StyledContainer>
          <StyledTitle center upper mb="x-small" size="large">{t('main.gallery.title')}</StyledTitle>
          <StyledSubtitle lh="1.5">{t('main.gallery.subtitle')}</StyledSubtitle>
          <MainGallery data={galleries}/>
          <ActiveLink  href={galleryHref} as={galleryAs}>
            <StyledContent.Link arrow>{t('main.gallery.button')}</StyledContent.Link>
          </ActiveLink>
        </StyledContainer>
      </StyledSection>
    </>
  )
}

HomePage.getInitialProps = async ({ api, req, res }) => {
  const response = await api.mainPage()
  return { ...response }
}

export default HomePage
